import { render, staticRenderFns } from "./EventEditing.vue?vue&type=template&id=0c9c3e3b"
import script from "./EventEditing.vue?vue&type=script&lang=js"
export * from "./EventEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports